import "./art_carousel.scss";

import { useCarouselState } from "@hooks/use_carousel_state";
import { EVENT_KEYS, useEventListener } from "@hooks/use_event_listener";
import * as types from "@root/types";
import React, { FC, useCallback } from "react";

import { ArtWindow } from "./art_window";
import { CloseButton, NextButton, PrevButton } from "./art_window_buttons";

interface ArtCarouselProps {
  artPieces: types.ArtPiece[];
  initialIdx: number;
  close: () => void;
}

const ArtCarousel: FC<ArtCarouselProps> = ({
  artPieces,
  initialIdx,
  close,
}) => {
  const { current, next, previous } = useCarouselState<types.ArtPiece>(
    artPieces,
    artPieces[initialIdx],
  );

  const keyDownHandler = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === EVENT_KEYS.ArrowLeft) {
        previous();
      }
      if (e.key === EVENT_KEYS.ArrowRight) {
        next();
      }
    },
    [previous, next],
  );

  useEventListener("keydown", keyDownHandler);

  if (!current) {
    return null;
  }

  return (
    <div className="art-carousel--window-wrapper">
      <PrevButton previous={previous} />
      <ArtWindow artPiece={current} />
      <NextButton next={next} />
      <CloseButton close={close} />
    </div>
  );
};

export { ArtCarousel, ArtCarouselProps };
